module.exports = __webpack_public_path__ + "fonts/AvenirLight.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AvenirLight.woff2
// module id = 472
// module chunks = 12